export default __webpack_public_path__ + "static/media/Saab.e587fab0.png";